import ContentLoader from 'react-content-loader'

type CategorySkeletonProps = {
  isMobile: boolean
}

export const CategorySkeleton: React.FC<CategorySkeletonProps> = ({
  isMobile,
}) => {
  if (isMobile) {
    return (
      <ContentLoader
        backgroundColor="#e0e0e0"
        foregroundColor="#ecebeb"
        height="19"
        id="load-title"
        speed={2}
        title="Carregando..."
        width="100%"
      >
        <rect x="28" y="4" rx="8" ry="8" width="50%" height="10" />
      </ContentLoader>
    )
  }

  return (
    <ContentLoader
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
      height="19"
      id="load-title"
      speed={2}
      title="Carregando..."
      width="100%"
    >
      <rect x="56" y="3.5" rx="8" ry="8" width="60%" height="12" />
    </ContentLoader>
  )
}
